var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneralInsights({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "general_insights",
    "data-name": "general insights",
    transform: "translate(-352 -47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8408",
    "data-name": "Rectangle 8408",
    width: 38,
    height: 38,
    rx: 19,
    transform: "translate(352 47)",
    fill: "#404246"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_140",
    "data-name": "Union 140",
    d: "M19165.412,1868.971a1.4,1.4,0,0,1,0-1.984l6.678-6.678a1.407,1.407,0,0,1,.992-.409,1.391,1.391,0,0,1,.924.351l1.926,1.7,4.309-4.15h-1.516a1.4,1.4,0,0,1,0-2.8h4.945a1.4,1.4,0,0,1,1.395,1.5l-.379,5.219a1.41,1.41,0,0,1-1.4,1.3c-.039,0-.072,0-.105,0a1.4,1.4,0,0,1-1.291-1.5l.111-1.529-5.061,4.875a1.4,1.4,0,0,1-1.9.038l-1.906-1.68-5.748,5.749a1.4,1.4,0,0,1-1.979,0Z",
    transform: "translate(-18804.609 -1795.963)",
    fill: "#f8f8f8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralInsights);
export default __webpack_public_path__ + "static/media/general-insights.69a6bae9153f9a2eb591b36fed6017ab.svg";
export { ForwardRef as ReactComponent };